import { DropdownOption } from "@/models/DropdownOption";

export const cardTypes: DropdownOption[] = [
	{
		label: "VISA",
		value: "VISA"
	},
	{
		label: "Mastercard",
		value: "Mastercard"
	}
]